import React from 'react';

/**
 * @enum {string}
 */
export const NodeType = {
  TRIGGER: 'TRIGGER',
  SEND_EMAIL: 'SEND_EMAIL',
  SEND_MESSAGE: 'SEND_MESSAGE',
  GENERATE_DOCUMENT: 'GENERATE_DOCUMENT',
  FILE_TAXES: 'FILE_TAXES',
  UPDATE_CRM: 'UPDATE_CRM',
  SOCIAL_POST: 'SOCIAL_POST',
  WAIT: 'WAIT',
  IF_CONDITION: 'IF_CONDITION',
  LOOP_START: 'LOOP_START',
  LOOP_END: 'LOOP_END',
  CODE: 'CODE',
  QUERY_DATABASE: 'QUERY_DATABASE',
  CONNECT_API: 'CONNECT_API',
  LOGGER: 'LOGGER',
  BROWSING_AGENT: 'BROWSING_AGENT',
  REGISTER_BUSINESS: 'REGISTER_BUSINESS',
  EXPAND_BUSINESS: 'EXPAND_BUSINESS',
  DASHBOARD: 'DASHBOARD',
  CREATE_WEBSITE: 'CREATE_WEBSITE',
  MANAGE_INVOICES: 'MANAGE_INVOICES',
  MARKET_RESEARCH: 'MARKET_RESEARCH',
  COMPLIANCE_CHECK: 'COMPLIANCE_CHECK',
  HIRE_EMPLOYEE: 'HIRE_EMPLOYEE',
  TODO_LIST: 'TODO_LIST',
  TODO_VIEW: 'TODO_VIEW',
  NOVEL_NODE: 'NOVEL_NODE',
  COMMENT: 'COMMENT'
};

/**
 * @enum {string}
 */
export const CredentialType = {
    API_KEY: 'API_KEY',
    DATABASE: 'DATABASE',
};

/**
 * @enum {string}
 */
export const ExecutionStatus = {
    IDLE: 'IDLE',
    RUNNING: 'RUNNING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
};

/**
 * @enum {string}
 */
export const DelegationType = {
    NONE: 'none',
    HUMAN: 'human',
    AGENT: 'agent'
};